<template>
  <div v-show="pageCount > 1" class="slider__pagination">
    <ul class="slider__dot-container" ref="pagList">
      <li class="slider__dot"
          :key="index"
          :class="{ 'slider__dot--active': (index === currentPage), 'clickable': isClickable }"
          v-for="(page, index) in pageCount">
        <button v-if="isClickable"
                class="slider__dot-inner"
                @click="whenClickItem(index)"
                :aria-label="labels.pagination.ariaLabel.replace('{0}', index)"
                :aria-current="(index === currentPage)? true: ''"/>
        <span v-else class="slider__dot-inner"/>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'pagination',
    props: {
      labels: {
        type: Object,
        required: true,
        default: undefined
      },
      taggingLabels: {
        type: Object,
        required: true
      },
      currentPage: {
        type: Number,
        required: true
      },
      pageCount: {
        type: Number,
        required: true
      },
      isClickable: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    data() {
      return {
        shiftAndTabHappened: false
      };
    },
    mounted() {
      this.setRole();
    },
    methods: {
      whenClickItem(index) {
        this.$emit('paginationClick', index);
      },
      setRole() {
        !this.isClickable ? this.$refs.pagList.setAttribute('role', 'none') : false;
      }
    }
  };
</script>
